/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {

	const ABSOLUTE_TYPE = 'absolute';
	const SCALINGABSOLUTE_TYPE = 'scalingAbsolute';
	const GENERICPAGE_TYPE = 'genericPage';
	const ABSOLUTE_LAYOUTPOSITIONING = 'absolute';
	const RELATIVE_LAYOUTPOSITIONING = 'relative';

	/**
	* Upgrades absolute and scalingAbsolute layouts to new genericPage type.
	* The new genericPage layout has a layoutPositioning property (absolute or relative)
	* Freeform templates are converted to Template1.
	**/

	class LayoutPositioningUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1012;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			return Promise.resolve()
				.then(() => {
					this._init();

					if (spec && spec.layout) {
						this._upgradeLayout(spec.layout);
						this._setTopLayoutPositioning(spec.layout);
					}
					return spec;
				});
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_init() {
			this._hasRelativeLayouts = false;
			this._hasAbsoluteLayouts = false;
		}

		_upgradeLayout(layout, parent) {
			if (layout.items) {
				// Recursively upgrade child layouts
				for (var item of layout.items) {
					this._upgradeLayout(item, layout);
				}
			}
			this._upgradeLayoutPositioning(layout, parent);
		}

		_upgradeLayoutPositioning(layout, parent) {
			if (layout.type === ABSOLUTE_TYPE) {
				layout.layoutPositioning = ABSOLUTE_LAYOUTPOSITIONING;
				layout.type = GENERICPAGE_TYPE;
				this._hasAbsoluteLayouts = true;
				this._upgradeAbsoluteTemplate(layout, parent);
			} else if (layout.type === SCALINGABSOLUTE_TYPE) {
				layout.layoutPositioning = RELATIVE_LAYOUTPOSITIONING;
				layout.type = GENERICPAGE_TYPE;
				this._hasRelativeLayouts = true;
			}
		}

		// Convert the freeform template (NoTemplate) to one of the non-freeform templates - Template1
		_upgradeAbsoluteTemplate(layout, parent) {
			parent.templateName = 'Template1';
			layout.css = 'templateBox aspectRatio_default';
			layout.items.unshift({
				'type': 'templateIndicator',
				'style': {
					'top': '0%',
					'left': '0%',
					'right': '0%',
					'bottom': '0%'
				}
			});
		}

		_setTopLayoutPositioning(layout) {
			if (this._hasAbsoluteLayouts && !this._hasRelativeLayouts) {
				layout.layoutPositioning = ABSOLUTE_LAYOUTPOSITIONING;
			} else if (this._hasRelativeLayouts && !this._hasAbsoluteLayouts) {
				layout.layoutPositioning = RELATIVE_LAYOUTPOSITIONING;
			}
			// Undefined otherwise
		}

	}

	return new LayoutPositioningUpgrade();
});
